var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4243 7.69829C24.946 7.44163 23.9427 7.17329 22.5777 8.12996L20.8627 9.34329C20.7343 5.71496 19.1593 4.29163 15.3327 4.29163H8.33268C4.34268 4.29163 2.79102 5.84329 2.79102 9.83329V19.1666C2.79102 21.85 4.24935 24.7083 8.33268 24.7083H15.3327C19.1593 24.7083 20.7343 23.285 20.8627 19.6566L22.5777 20.87C23.301 21.3833 23.931 21.5466 24.4327 21.5466C24.8643 21.5466 25.2027 21.4183 25.4243 21.3016C25.9027 21.0566 26.7077 20.3916 26.7077 18.7233V10.2766C26.7077 8.60829 25.9027 7.94329 25.4243 7.69829ZM13.5827 13.7766C12.381 13.7766 11.3893 12.7966 11.3893 11.5833C11.3893 10.37 12.381 9.38996 13.5827 9.38996C14.7843 9.38996 15.776 10.37 15.776 11.5833C15.776 12.7966 14.7843 13.7766 13.5827 13.7766Z",
    fill: "#B4BFD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video-icon.ca22e3892b17d683172afb0cdfaa0407.svg";
export { ForwardRef as ReactComponent };